import styled from 'styled-components'
import Icon from './Icon'

const GiftIcon = styled(Icon).attrs({
  type: 'gift',
})``

export default GiftIcon
